export const pressReleases = (state) => {
  return state.pressReleases
}
